import { Link } from "@tanstack/react-router";

import banner from "../../assets/imgs/banner.png";

const Hero = () => {
  return (
    <section className="container m-auto flex-col lg:flex-row flex items-center mb-3 mt-24">
      <div className="lg:w-1/2 px-3 py-6 lg:p-0 hero-text">
        <h1>Read. Play. Win.</h1>
        <p>
          Pick a book or article, dive into the story, and then test your skills
          with a fun quiz. The more you read, the more points you earn!
        </p>
        {/* Signups disabled 2026-07-14 — was to="/sign-up" */}
        <Link to="/sign-in" className="orange-button">
          Start Reading
        </Link>
      </div>
      <div className="lg:w-1/2">
        <img src={banner} alt="" className="w-full" />
      </div>
    </section>
  );
};

export default Hero;
